import React from "react";
//#region types
import { UserProfileProps } from "models/propTypes/userProfilePropTypes";
import { StyleEnums } from "models/enums";
import { UserProfileContainerProps } from "models/propTypes/navListPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import { Icon, ProfileImage, RoundButton, StyledButton } from "components/common";
import ProfileMoreActions from "./profileMoreActions";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const UserProfile: React.FC<UserProfileProps & UserProfileContainerProps> = (props) => {
  return (
    <Grid container className={cssExports.navProfileContainer}>
      <Grid
        container
        item
        alignItems="center"
        className={cssExports.navProfileContainerInner}
        spacing={1}
        wrap="nowrap"
      >
        <Grid item className={cssExports.dashboardProfileAvatar}>
          <ProfileMoreActions
            userName={props.userName}
            button={
              <StyledButton displayType={StyleEnums.DisplayType.None} testId="userProfileButton">
                <ProfileImage
                  id={props.profileId}
                  name={props.userName}
                  className={cssExports.dashboardProfileImage}
                ></ProfileImage>
              </StyledButton>
            }
            navCollapsed={props.collapsed}
          />
        </Grid>
        <Grid item xs className={cssExports.userDetailsContainer}>
          <Grid item container justifyContent="flex-start" className={cssExports.userNameContainer}>
            {props.userName ? (
              <label className={cssExports.userName}>{props.userName.split(" ")[0]}</label>
            ) : (
              <Skeleton variant="text" width="100%" />
            )}
          </Grid>
          <Grid item container justifyContent="flex-start" className={cssExports.companyNameContainer}>
            {props.companyName ? (
              <label className={cssExports.companyName}>{props.companyName}</label>
            ) : (
              <Skeleton variant="text" width="100%" />
            )}
          </Grid>
        </Grid>
        <Grid item className={cssExports.iconMore}>
          <ProfileMoreActions
            userName={props.userName}
            button={
              <RoundButton size="xs">
                <Icon icon={IconDefinitionConstants.WMore} className={cssExports.navListIcon} />
              </RoundButton>
            }
            navCollapsed={props.collapsed}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UserProfile;
